import React, { PropsWithChildren, useRef } from 'react';
import { Tooltip, TooltipPlacement } from '../../../../components/atoms/Tooltip';

// Components
import { KeyEvent } from '../../../../types/KeyEvent';

// preventing default behaviour to scroll on keydown.
// as we use keyUp to toggle the Tabs
const preventScrolling = (event: React.KeyboardEvent<HTMLButtonElement>) => {
  if (event.code === KeyEvent.ArrowUp || event.code === KeyEvent.ArrowDown) {
    event.preventDefault();
  }
};
type OnClickEvent = {
  panelId: string;
  innerEvent: React.MouseEvent<HTMLButtonElement, MouseEvent>;
};

type OnFocusEvent = {
  panelId: string;
  innerEvent: React.FocusEvent<HTMLButtonElement>;
};

export type PALTabProps = PropsWithChildren<{
  id: string;
  title: string;
  dependentPanelId: string;
  activePanelId?: string;
  accessKey?: string;
  panelAreaExpanded: boolean;
  onClick: (e: OnClickEvent) => void;
  onKeyUp?: React.KeyboardEventHandler<HTMLButtonElement>;
  onFocus: (e: OnFocusEvent) => void;
}>;

export function PALTab(props: PALTabProps) {
  const buttonRef = useRef<HTMLButtonElement>(null);

  return (
    <Tooltip attachTo={buttonRef} hideTooltipFromScreenReader placement={TooltipPlacement.LEFT}>
      {/* // if used correctly and wisely, accesskeys are a11y enhancement // eslint-disable-next-line */}
      {/* eslint-disable-next-line jsx-a11y/no-access-key */}
      <button
        ref={buttonRef}
        type="button"
        id={props.id}
        role="tab"
        className="pal-tab__tablink"
        title={props.title}
        tabIndex={props.dependentPanelId === (props.activePanelId ?? null) ? 0 : -1}
        aria-controls={props.dependentPanelId}
        aria-selected={props.panelAreaExpanded && props.dependentPanelId === (props.activePanelId ?? null)}
        accessKey={props.accessKey}
        onClick={event =>
          props.onClick({
            panelId: props.dependentPanelId,
            innerEvent: event,
          })
        }
        onKeyDown={preventScrolling}
        onKeyUp={props.onKeyUp}
        onFocus={event =>
          props.onFocus({
            panelId: props.dependentPanelId,
            innerEvent: event,
          })
        }
      >
        <span className="pal-tab__tablink-container">
          <span className="invisible">{props.title}</span>
          {props.children}
        </span>
      </button>
    </Tooltip>
  );
}
